import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  totals: {
    textAlign: "right",
  },
  section: {
    marginBottom: theme.spacing(),
    marginTop: theme.spacing() * 2,
    "&:first-child": {
      marginTop: 0,
    },
  },
  subSection: {
    marginBottom: theme.spacing() * 3,
  },
  borderTop: {
    borderTop: "1px solid",
  },
}));

export default ({
  cardsToEvaluatePrice,
  cardsToNotEvaluatePrice,
  currencyCaption,
  paymentDiscount,
}) => {
  const classes = useStyles();
  const totalPrice = cardsToEvaluatePrice + cardsToNotEvaluatePrice;
  const discount =
    paymentDiscount && totalPrice ? totalPrice * (1 - paymentDiscount) * -1 : 0;

  return (
    <>
      <Typography variant="h5" className={classes.section}>
        Totals
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.subSection}
      >
        Running totals for your order updated in real-time.
      </Typography>
      <Grid container className={[classes.section, classes.totals].join(" ")}>
        <Grid item xs={6}>
          <Typography component="span">Evaluation Fee</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography component="span">
            <strong>
              {currencyCaption}
              {cardsToEvaluatePrice.toFixed(2)}
            </strong>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography component="span">Grading Fee</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography component="span">
            <strong>
              {currencyCaption}
              {cardsToNotEvaluatePrice.toFixed(2)}
            </strong>
          </Typography>
        </Grid>
        {discount ? (
          <>
            <Grid item xs={6}>
              <Typography component="span">Discount</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography component="span">
                <strong>
                  {currencyCaption}
                  {discount.toFixed(2)}
                </strong>
              </Typography>
            </Grid>
          </>
        ) : null}
        <Grid item xs={6}>
          <Typography component="span">Shipping</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography component="span">
            <strong>TBD</strong>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography component="span">Shipping Insurance</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography component="span">
            <strong>TBD</strong>
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.borderTop}>
          <Typography component="span">Total</Typography>
        </Grid>
        <Grid item xs={6} className={classes.borderTop}>
          <Typography component="span">
            <strong>
              {currencyCaption}
              {(totalPrice + discount).toFixed(2)}
            </strong>
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
